<template>
    <div class="www pt-2 pb-6 select-none">
        <div class="text-sm font-medium text-gray-700">
            {{ t('templateShowWideEditor') }}
        </div>

        <div class="pt-5">
            <SwitchButton
                v-model="stateRepository.states.wideEditorActive"
                :state="stateRepository.states.wideEditorActive ? 'success' : 'neutral'"
                :label-on="t('templateShowWideEditorShow')"
                :label-off="t('templateShowWideEditorHide')"
            />
        </div>
    </div>
</template>

<script setup>
    import { watch } from 'vue';
    import { keeper } from '../composables/utils';
    import { t } from '../composables/i18n';
    import SwitchButton from '../ui/SwitchButton.vue';

    defineExpose({
        name: 'WideSMSEditorWidget',
    });

    const props = defineProps({
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const stateRepository = props.stateRepository;

    watch(
        () => stateRepository.states.wideEditorActive,
        (newValue) => {
            keeper('wideEditor', newValue);
        },
    );
</script>
